import objectAssign from "object-assign";
import initialState from "./initialState";
import { UPDATE_COMPANY_INFO } from "../actions/actionTypes";

export default function contactInfoReducer(
  state = initialState.companyInfo,
  action
) {
  switch (action.type) {
    case UPDATE_COMPANY_INFO:
      return objectAssign({}, state, action.companyInfo);
    default:
      return state;
  }
}
